import * as React from "react";
import { DownloadButton } from "./DownloadButton";
import "./DownloadComponent.scss";
import { translate } from "../locales/src/translate";
import { parsedHtmlElement } from "../form/interface/formContentData";

interface DownloadComponentProps {
  base64String: string;
  name: string;
  downloadInformationContent?: parsedHtmlElement;
}

export const DownloadComponent = (props: DownloadComponentProps) => {
  if (!props.base64String) {
    return <div>{translate("Klantondersteuning_Formulieren_NoPDFButtonFound")}</div>;
  }
  return (
    <div className="download-block">
      <div className="download-block__content">
        {props.downloadInformationContent ? props.downloadInformationContent : translate("Klantondersteuning_Formulieren_UwVraagDownloadenTekst")}
      </div>
      <DownloadButton base64String={props.base64String} name={props.name} />
    </div>
  );
};
 